import React, { useState, useEffect } from 'react';
import ExecuteAxios from "../../../Components/ExecuteAxios/ExecuteAxios";
import "./ProductFilters.css";
import ComboBox from 'Components/ComboBox/ComboBox';
import OptionsDataByAttributePath from 'Components/Options/optionsData/OptionsDataByAttributePath';
import InputField from 'Components/Input/InputField';
import Button from 'Components/Button/Button';
import Panel from 'Components/Panel/Panel';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import useDebouncedValue from 'Components/UseDebouncedValue/useDebouncedValue';

const ProductFilters = ({
    onUpdateFilters,
    onUpdateSupplierIdSelected,
    supplierIdSelected
}) => {

    const [isActive, setIsActive] = useState('S');
    const [suppliers, setSuppliers] = useState([]);
    const [productCodeSelected, setProductCodeSelected] = useState();
    const debouncedProductCode = useDebouncedValue(productCodeSelected);

    useEffect(() => {
        const fetchData = async () => {
            const suppliers = await ExecuteAxios.api('get', '/supplier/get-active-supplier-list/');
            setSuppliers(suppliers);
        };

        fetchData();
    }, []);

    useEffect(() => {
        filterProduct()
    }, [isActive, debouncedProductCode, supplierIdSelected]);

    const PanelListStyle = {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '20%',
        maxHeight: '20%',
        width: '100%',
        borderBottom: '2px solid rgb(204, 204, 204)'
    };

    const styleFilterButton = {
        width: '85px',
        margin: '10px 15px 10px 0px',
        float: 'right',
        color: 'green',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em',
        cursor: 'pointer'
    };

    // Só repassa os filtros; a busca (paginada) é feita pela grid de Produtos
    function filterProduct() {
        onUpdateFilters({
            productCode: debouncedProductCode || null,
            supplierId: supplierIdSelected || null,
            isActive: isActive
        })
    }

    function isActiveSetter() {
        return setIsActive(isActive === 'S' ? 'N' : 'S')
    }

    const productOptions = OptionsDataByAttributePath(suppliers, ['description'], null, true)

    return (
        <>
            <Panel style={PanelListStyle}
                titlePage={'Filtros produto'}
                canViewCRUD={true}
            >
                <LoadingIndicator loaded={true}>
                    <div id='first-colum-filter-product'>
                        <div id='filter-atributtes'>
                            <div id='product-filter'>
                                <span className='span-product-filter'>Fornecedor</span>
                                <ComboBox setAttribute={onUpdateSupplierIdSelected}
                                    optionsData={productOptions}
                                    style={{ width: '150px', cursor: 'pointer' }}
                                    value={supplierIdSelected}
                                    defaultValue={supplierIdSelected}
                                />
                            </div>

                            <div id='product-filter'>
                                <span className='span-product-filter'>Referência</span>
                                <InputField
                                    setAttribute={setProductCodeSelected}
                                    value={productCodeSelected}
                                    style={{ width: '150px' }}
                                />
                            </div>

                            <div id='product-filter'>
                                <span className='span-product-filter'>Somente ativos</span>
                                <InputField
                                    setAttribute={(event) => isActiveSetter(event)}
                                    value={isActive}
                                    checked={isActive === 'S'}
                                    readOnly={false}
                                    disabled={false}
                                    type="checkbox"
                                    style={{ cursor: 'pointer' }}
                                />
                            </div>
                        </div>
                    </div>
                </LoadingIndicator>
            </Panel>
        </>
    );
}
export default ProductFilters;